class AnnouncementBar extends HTMLElement {
  constructor() {
    super();

    // Add class so we know it's there
    document.body.classList.add('announcement-bar-visible');

    // The swiper element
    this.swiperElement = this.querySelector('[data-swiper-announcement-bar]');

    // Default swiper options
    this.swiperOptions = {
      loop: true,
      autoplay: true,
      slidesPerView: 1,
      direction: 'horizontal'
    }

    // Get options from element data and combine with this.options
    if (this.swiperElement?.dataset?.swiperAnnouncementBarOptions) {
      const dataOptions = JSON.parse(this.swiperElement.dataset.swiperAnnouncementBarOptions);
      this.swiperOptions = {
        ...this.swiperOptions,
        ...dataOptions
      };
    }

    // Init the swiper
    this.init();
  }

  /**
   * Init
   */
  init() {

    this.swiperInstance = new Swiper(this.swiperElement, this.swiperOptions);

    if(Shopify.designMode && this.swiperInstance) {

      window.addEventListener('shopify:section:load', () => {
        this.swiperInstance.update();
      });

      window.addEventListener('shopify:block:select', (event) => {
        this.swiperInstance.update();
        this.handleThemeEditorEvents(event);
      });
    }
  }

  /**
   * Handles the theme editor block change/edit event
   * @param {Object} event
   */
  handleThemeEditorEvents(event) {
    // Slide to slide based on the data attribute from the target and add 1 to get the slide index
    this.swiperInstance.slideTo(parseInt(event.target.dataset.swiperSlideIndex) + 1);
  }


}

if(!customElements.get('announcement-bar')) {
  customElements.define('announcement-bar', AnnouncementBar);
}
